import React from 'react';
import { Title, useTranslate, useAuthenticated } from 'react-admin';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const sxBox = {
    backgroundColor: 'primary.main',
    color: '#FFF'
};

const sxGrid = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start'
};

const sxButton = {
    backgroundColor: '#000',
    '&:hover': {
        backgroundColor: '#000'
    }
};

const Marketing = () => {
    const translate = useTranslate();
    useAuthenticated();

    return (
        <Box m={5}>
            <Title title={translate('Marketing')} />
            <Grid container>
                <Grid item xs={12} lg={10}>
                    <Box sx={sxBox} p={4}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sx={sxGrid}>
                                <Typography variant="h2" gutterBottom>{translate('Press kit')}</Typography>
                                <Button variant="contained" sx={sxButton} href="#" target="_blank">{translate('Download')}</Button>
                            </Grid>
                            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <img src={`${process.env.PUBLIC_URL}/img/press-kit.png`} alt="Press kit" style={{ maxWidth: '100%' }} />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Marketing;